import React, { useState, useEffect, useContext } from "react";
import { useSpring, animated } from "react-spring";
import { TypeAnimation } from 'react-type-animation';
import "./MainHero.css";
import { NavLink } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

function MainHeroSection() {
  const {
    isAuthenticated,
    isSubscribed,
    setIsSubScribed,
    hasUsedFreeTrial,
    setHasUsedFreeTrial,
    daysLeft, setDaysLeft,
    paymentDate,
    setPaymentDate,
    subScribedPlan,
    setSubScribePlan,
    subScriptionEndDate,
    setSubscriptionEndDate,
    plan,
    setPlan,
    subScriptionAmount,
    setSubScriptionAmount,
    paymentMethod, setPaymentMethod,
    paymentStatus, setPaymentStatus,
    planStatus, setPlanStatus,
    subScriptionId, setSubScriptionId
  } = useContext(AuthContext);
  return (
    <div className="relative hero overflow-hidden" style={{
      height: `${"100%"}`,
      display: "flex",
      alignItems: "center",
    }}>
      <div
        className={`absolute top-0 left-0 w-full h-full bg-hero-image bg-cover bg-center d-flex 2xl:h-screen xl:h-screen`}
        style={{
          backgroundImage: `linear-gradient(0deg, rgba(17, 25, 32, 0.64) 0%, rgba(17, 25, 32, 0.64) 100%), url('/hero_background3.webp')`,
          backgroundPosition: `bottom center`

        }}
      ></div>

      <div className="relative z-10 pt-20 2xl:pb-16 xl:pb-16 lg:pb-16 md:pb-6 sm:pb-6 pb-6 md:py-32 md:px-10 mb-10 text-white text-center justify-center items-center">
        <span className=" w-full justify-center mb-0 tracking-tighter  md:text-6xl font-bold leading-snug">
          <h1 className="text-4xl  md:text-6xl font-bold leading-snug">
            Welcome to <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA] ">IzzyAI</span>
          </h1>
          <TypeAnimation
            sequence={[
              'Your Speech Language Companion!', // Type the string
              1000, // Wait for 1 second
              '', // Delete the string (clear the text)
              1000, // Wait for 1 second before restarting
            ]}
            wrapper="span"
            speed={100} // Typing speed (ms per character)
            deletionSpeed={50} // Deletion speed (ms per character)
            style={{ display: 'inline-block' }}
            repeat={Infinity} // Repeat infinitely
            cursor={false} // Display a cursor
          />

        </span>
        <p className="text-xl mt-2 px-5">
          Embark on a journey to clear and confident speech with IzzyAI. Our
          avatar-led exercises, powered by AI, target Articulation, Stammering,
          Voice and Language Disorders. Let's unlock your communication
          potential together.V1
        </p>
        <p className="relative mt-5 text-lg font-bold px-5 2xl:mt-10 xl:mt-10 lg:mt-10"><span className="bg-clip-text text-transparent bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA] ">*</span>Patent Pending</p>
        {
          <div className="flex mt-5 justify-center items-center 2xl:mt-10 xl:mt-10 lg:mt-10">
            <div className=" w-[200px]z-0 rounded-[40px] relative p-[8px] md:z-10 custom-gradient-box">
              <button id="go_to_agentverse" className="bg-[#111920] relative z-50 flex w-full items-center gap-[10px] rounded-[40px]  ">
                <NavLink
                  to={isAuthenticated ? "/pricing" : "/signup"}
                  className="px-6 py-3 bg-clip-text text-transparent bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA] rounded-[40px] border border-black dark:border-[#283642] hover:border-transparent dark:hover:border-transparent cursor-pointer flex items-center uppercase font-bold"
                >
                  {
                    isSubscribed ?
                      planStatus === "Trial" ? `Free Trial Ends In ${daysLeft} Days` : `Enjoy Your Plan`
                        :
                        "Start Free Trial"
                  }
                </NavLink>
              </button>
            </div>
          </div>
        }
      </div>


    </div>
  );

}

export default MainHeroSection;
